/* eslint no-inline-comments: 0 */

const Settings = () => import( /* webpackChunkName: "group-genai" */ `./settings.vue` );
const Models = () => import( /* webpackChunkName: "group-genai" */ `./models-list.vue` );

export default {
	path: `genai`,
	children: [
		{
			path: `settings`,
			name: `genai-settings`,
			component: Settings,
			meta: {
				title: `GenAI Settings`
			}
		},
		{
			path: `models`,
			name: `genai-models`,
			component: Models,
			meta: {
				title: `GenAI Models`
			}
		}
	]
};
